import axios from "axios";

export const centralMonitorData = () => async (dispatch, getState) => {
  let token = JSON.parse(localStorage.getItem("token"));
  const { loading } = getState().CentralMonitoringScreenReducer;
  if (loading) return;
  
  dispatch({ type: "FETCH_DATA_REQUEST" });
  try {
    const url = `${process.env.REACT_APP_DEVICE_API_URL}/api/all`;
    const response = await axios({
      method: 'GET',
      url: url,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    if (response.status === 200) {
      const updatedData = response.data.map(item => ({ ...item, status: "Healthy" }));
      
      const { dashboardData } = getState().CentralMonitoringScreenReducer;
      const dataChanged = JSON.stringify(dashboardData) !== JSON.stringify(updatedData);
      
      if (dataChanged) {
        dispatch({
          type: 'CENTRAL_MONITOR_DATA_SUCCESS',
          payload: updatedData,
        });
      } else {
        dispatch({ type: 'FETCH_DATA_COMPLETE' });
      }
    }
  } catch (error) {
    dispatch({
      type: 'CENTRAL_MONITOR_DATA_FAILURE',
      payload: error.message,
    });
  }
};

export const stopAutoRefresh = () => ({
  type: 'STOP_AUTO_REFRESH'
});